import { render, staticRenderFns } from "./LoginYC.vue?vue&type=template&id=044ab55a&scoped=true"
import script from "./LoginYC.vue?vue&type=script&lang=js"
export * from "./LoginYC.vue?vue&type=script&lang=js"
import style0 from "./LoginYC.vue?vue&type=style&index=0&id=044ab55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ab55a",
  null
  
)

export default component.exports